/**
 * Normalizes a URL by ensuring it has a protocol (https://).
 * If the URL already has http:// or https://, it returns it unchanged.
 * Otherwise, it prepends https:// to the URL.
 *
 * @param url - The URL to normalize (can be with or without protocol)
 * @returns The normalized URL with https:// protocol
 *
 * @example
 * ```typescript
 * normalizeUrl('pub.shfiles.co/path/to/file.png')
 * // Returns: 'https://pub.shfiles.co/path/to/file.png'
 *
 * normalizeUrl('https://pub.shfiles.co/path/to/file.png')
 * // Returns: 'https://pub.shfiles.co/path/to/file.png'
 *
 * normalizeUrl('http://example.com/image.jpg')
 * // Returns: 'http://example.com/image.jpg'
 * ```
 */
export function normalizeUrl(url: string | null | undefined): string | null {
  if (!url) {
    return null;
  }

  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }

  return `https://${url}`;
}
